/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-10 16:38:38
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 16:46:25
 * @FilePath: /chaoyongtuan/src/views/talentCRM/tagManagement/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

function getColumns() {
	let arr = [
		{
			key: '',
			label: '标签名称',
			type: () => import('./components/tableCell/tagInfo.vue'),
			minWidth: '150',
		},
		{
			key: '',
			label: '达人数量',
			type: () => import('./components/tableCell/talentCount.vue'),
			minWidth: '150',
		},
		{
			key: 'add_time',
			label: '创建时间',
			type: 'rdText',
			minWidth: '150',
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '80',
			fixed: 'right',
			align: 'right',
		},
	];
	return arr;
}
export default getColumns;
